(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Coveo"), require("CoveoForSitecoreUserContext"));
	else if(typeof define === 'function' && define.amd)
		define(["Coveo", "CoveoForSitecoreUserContext"], factory);
	else if(typeof exports === 'object')
		exports["CoveoForSitecore"] = factory(require("Coveo"), require("CoveoForSitecoreUserContext"));
	else
		root["CoveoForSitecore"] = factory(root["Coveo"], root["CoveoForSitecoreUserContext"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_20__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(2);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	/// <reference path="../typings/CoveoForSitecore/CoveoForSitecore.JQuery.d.ts"/>
	var CoveoForSitecore = __webpack_require__(2);
	Coveo.initCoveoForSitecore = function (element, action, options) {
	    if (action === "init") {
	        CoveoForSitecore.initializeSearch(element, options);
	    }
	    else if (action === "initSearchbox") {
	        CoveoForSitecore.initializeSearchbox(element, options);
	    }
	    else {
	        console.error("The action '" + action + "' is not part of the coveoForSitecore plugin. Ignoring action.");
	    }
	};
	Coveo.initializeJQuery = function (jQueryInstance) {
	    Coveo.$ = jQueryInstance;
	    Coveo.initializeCoveoForSitecorePlugin();
	};
	Coveo.initializeCoveoForSitecorePlugin = function () {
	    if (typeof (Coveo.$) !== "undefined" && typeof (Coveo.$.fn) != "undefined") {
	        Coveo.$.fn.coveoForSitecore = function (action, options) {
	            Coveo.initCoveoForSitecore(this[0], action, options);
	            return this;
	        };
	    }
	};
	(function (jQueryInstance) {
	    if (typeof (jQueryInstance) !== "undefined") {
	        Coveo.initializeJQuery(jQueryInstance);
	    }
	})(typeof (Coveo) !== "undefined" && typeof (Coveo.$) !== "undefined" ? Coveo.$ : jQuery);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	var _this = this;
	var PluginOptions_1 = __webpack_require__(3);
	var CoveoForSitecoreBase_1 = __webpack_require__(4);
	var TabsBinding_1 = __webpack_require__(17);
	var Searchbox_1 = __webpack_require__(18);
	var SearchEndpointHelper_1 = __webpack_require__(12);
	var UserContextHandler_1 = __webpack_require__(19);
	var CoveoForSitecoreUserContext = __webpack_require__(20);
	var CoveoForSitecoreRecommendationsBase_1 = __webpack_require__(21);
	exports.OmniboxResultList = __webpack_require__(22);
	exports.CoveoDistanceResources = __webpack_require__(23);
	var recommendations = new CoveoForSitecoreRecommendationsBase_1["default"]();
	exports.userContext = typeof (CoveoForSitecoreUserContext) !== "undefined" ? CoveoForSitecoreUserContext.handler : new UserContextHandler_1["default"]();
	exports.componentsOptions = new PluginOptions_1["default"]();
	exports.tabsBinding = new TabsBinding_1["default"]();
	exports.SearchEndpointHelper = SearchEndpointHelper_1["default"];
	exports.defaults = new PluginOptions_1["default"]();
	function initializeSearch(searchComponent, options) {
	    exports.tabsBinding.applyBindings();
	    if (!_isExistingPlugin(searchComponent)) {
	        if (typeof (options.userContext) === "undefined") {
	            options.userContext = exports.userContext.getContext();
	        }
	        exports.plugin = new CoveoForSitecoreBase_1["default"](searchComponent, options, exports.defaults);
	        exports.plugin.initialize();
	    }
	}
	exports.initializeSearch = initializeSearch;
	function initializeSearchbox(searchComponent, options) {
	    if (typeof (options.userContext) === "undefined") {
	        options.userContext = exports.userContext.getContext();
	    }
	    exports.plugin = new Searchbox_1["default"](searchComponent, options, exports.defaults);
	    exports.plugin.initialize();
	}
	exports.initializeSearchbox = initializeSearchbox;
	exports.initRecommendations = function (element, userContext) {
	    recommendations.initRecommendations(element, userContext || _this.userContext.getContext());
	};
	exports.initRelatedQuery = function (element, searchInterfaceElement, userContext, options) {
	    recommendations.initRelatedQuery(element, searchInterfaceElement, userContext || _this.userContext.getContext(), options);
	};
	function _isExistingPlugin(searchComponent) {
	    return exports.plugin && exports.plugin.element && exports.plugin.element.id === searchComponent.id;
	}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	var PluginOptions = (function () {
	    function PluginOptions() {
	        this.analyticsCustomMetadata = {};
	        this.analyticsEndpointUri = "/coveo/rest/v6/analytics/";
	        this.boostExpressions = "";
	        this.clientLanguageFieldName = "";
	        this.clientLanguageName = "";
	        this.componentRefreshCallback = null;
	        this.defaultSortType = "Relevancy";
	        this.defaultSortField = "";
	        this.defaultSortCriteriaNoSpace = "Relevancy";
	        this.defaultSortCriteriaLowercase = "relevancy";
	        this.enableClientSideLogging = false;
	        this.externalCollections = [];
	        this.externalSources = [];
	        this.externalSourcesFromCurrentTab = [];
	        this.externalCollectionsFromCurrentTab = [];
	        this.filterExpression = "";
	        this.filterResultOnLatestVersion = true;
	        this.filterResultsOnCurrentCulture = false;
	        this.indexSourceName = "";
	        this.isEditingInPageEditor = false;
	        this.isInitialized = false;
	        this.isPreviewingInPageEditor = false;
	        this.isPreviewingInPageEditorWithSimulatedDevice = false;
	        this.keepOmniboxSuggestionsProvidersDefaultOrdering = true;
	        this.latestVersionFieldName = "";
	        this.omniboxDataRowIndexCounter = 0;
	        this.pageFullPath = "";
	        this.pageName = "";
	        this.restEndpointUri = "/coveo/rest/";
	        this.resultListInfiniteScrollContainer = window;
	        this.searchboxPlaceholderText = "";
	        this.searchRedirectionUrl = "";
	        this.searchRedirectionItemName = "";
	        this.sendToSitecoreAnalytics = false;
	        this.sitecoreItemId = "";
	        this.sitecoreItemUri = "";
	        this.siteName = "";
	        this.userContext = {};
	    }
	    return PluginOptions;
	}());
	exports.__esModule = true;
	exports["default"] = PluginOptions;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	/// <reference path="../../typings/coveo-search-ui/CoveoJsSearch.d.ts"/>
	var Coveo = __webpack_require__(5);
	var Logger_1 = __webpack_require__(6);
	var DefaultSortHandler_1 = __webpack_require__(7);
	var ExpressionsHelper_1 = __webpack_require__(8);
	var SearchEndpointHelper_1 = __webpack_require__(12);
	var OmniboxResultListHandler_1 = __webpack_require__(13);
	var SitecoreAnalyticsHandler_1 = __webpack_require__(14);
	var CoveoForSitecoreBase = (function () {
	    function CoveoForSitecoreBase(searchComponent, options, defaultOptions) {
	        this.isInPageEditorCssClass = "coveo-page-editor";
	        this.isEditingInPageEditorCssClass = "coveo-page-editor-editing";
	        this.isPreviewingInPageEditorCssClass = "coveo-page-editor-previewing";
	        this.isPreviewingInPageEditorWithSimulatedDeviceCssClass = "coveo-page-editor-previewing-with-simulator";
	        this.element = searchComponent;
	        this.domElement = Coveo.$$(searchComponent);
	        this.options = _.extend({}, defaultOptions, options);
	        this.logger = new Logger_1["default"](this.options.enableClientSideLogging);
	        this.expressionsHelper = new ExpressionsHelper_1["default"]();
	        this.omniboxResultListHandler = new OmniboxResultListHandler_1["default"]();
	        this.sitecoreAnalyticsHandler = new SitecoreAnalyticsHandler_1["default"](this.options);
	        this.defaultSortHandler = new DefaultSortHandler_1["default"](options);
	        this.context = {};
	    }
	    CoveoForSitecoreBase.prototype.initialize = function () {
	        var _this = this;
	        this.logger.log("Initializing search.");
	        this.initializeSearchOptions();
	        if (!this.options.isInitialized) {
	            this.addPageEditorCssClasses();
	            this.addResultListHeaderCssClasses();
	            this.domElement.on(Coveo.InitializationEvents.afterInitialization, function () {
	                _this.trySetOriginContextInUsageAnalytics();
	                if (!Coveo.HashUtils.getValue("sort", window.location.hash)) {
	                    Coveo.state(_this.element, "sort", _this.options.defaultSortCriteriaLowercase);
	                }
	            });
	            // Merge the options we need to add with the options that are already set.
	            var mergedOptions = Coveo.Utils.extendDeep({
	                Facet: {},
	                SearchInterface: {}
	            }, this.options);
	            Coveo.init(this.element, mergedOptions);
	        }
	        this.doPostInitializationActions();
	    };
	    CoveoForSitecoreBase.prototype.doPostInitializationActions = function () {
	        var _this = this;
	        _.forEach(this.domElement.findAll(".CoveoQuerybox input, .CoveoOmnibox input"), function (element) {
	            element.setAttribute("placeholder", _this.options.searchboxPlaceholderText);
	        });
	    };
	    CoveoForSitecoreBase.prototype.initializeSearchOptions = function () {
	        var _this = this;
	        SearchEndpointHelper_1["default"].initializeEndpoint(this.options);
	        if (this.options.enableClientSideLogging) {
	            Coveo.Logger.enable();
	        }
	        if (!this.options.isInitialized) {
	            this.addPageEditorCssClasses();
	            this.domElement.on(Coveo.QueryEvents.buildingQuery, function (e, args) {
	                _this.defaultSortHandler.addSortCriteriaToQuery(args.queryBuilder);
	                _this.addContextToQuery(args.queryBuilder);
	            });
	            this.domElement.on(Coveo.InitializationEvents.afterInitialization, function () {
	                _this.registerSearchEvents();
	                _this.options.isInitialized = true;
	            });
	            if (this.options.sendToSitecoreAnalytics) {
	                this.sitecoreAnalyticsHandler.registerSitecoreAnalytics(this.domElement);
	            }
	        }
	    };
	    CoveoForSitecoreBase.prototype.postAnalytics = function (eventAction, eventType, eventData) {
	        this.sitecoreAnalyticsHandler.postAnalytics(eventAction, eventType, eventData);
	    };
	    CoveoForSitecoreBase.prototype.addPageEditorCssClasses = function () {
	        if (this.isInPageEditor()) {
	            this.domElement.addClass(this.isInPageEditorCssClass);
	            if (this.options.isEditingInPageEditor) {
	                this.domElement.addClass(this.isEditingInPageEditorCssClass);
	            }
	            if (this.options.isPreviewingInPageEditor) {
	                this.domElement.addClass(this.isPreviewingInPageEditorCssClass);
	            }
	            if (this.options.isPreviewingInPageEditorWithSimulatedDevice) {
	                this.domElement.addClass(this.isPreviewingInPageEditorWithSimulatedDeviceCssClass);
	            }
	        }
	    };
	    CoveoForSitecoreBase.prototype.addResultListHeaderCssClasses = function () {
	        // Both the mobile and full search interface does not use the
	        // same CSS class for the result list header.
	        var elements = this.getDomElementsMatchingSelector(".coveo-results-header, .coveo-result-header-section");
	        _.filter(elements, function (element) {
	            return typeof (element) !== "undefined" &&
	                !element.hasClass("CoveoQuerySummary") &&
	                element.hasClass("CoveoQueryDuration") &&
	                element.hasClass("CoveoSort");
	        }).forEach(function (element) {
	            element.addClass("coveo-empty");
	        });
	    };
	    CoveoForSitecoreBase.prototype.getFilterExpressions = function () {
	        return this.expressionsHelper.getFilterExpression(this.options);
	    };
	    CoveoForSitecoreBase.prototype.registerSearchEvents = function () {
	        var _this = this;
	        this.logger.log("Registering search events.");
	        this.domElement.on(Coveo.QueryEvents.buildingQuery, function (e, args) {
	            var optionsWithTabContent = _this.getOptionsWithTabExternalContent(args.queryBuilder.tab);
	            args.queryBuilder.advancedExpression.add(_this.expressionsHelper.getSearchExpression(optionsWithTabContent));
	            args.queryBuilder.constantExpression.add(_this.expressionsHelper.getFilterExpression(optionsWithTabContent));
	        });
	        this.domElement.on(Coveo.AnalyticsEvents.changeAnalyticsCustomData, function (e, args) {
	            var options = _this.options;
	            if (options) {
	                if (options.clientLanguageName) {
	                    args.language = options.clientLanguageName;
	                }
	                if (options.pageName) {
	                    args.originLevel1 = options.pageName;
	                }
	                if (options.analyticsCustomMetadata) {
	                    _.extend(args.metaObject, options.analyticsCustomMetadata);
	                }
	            }
	        });
	        if (this.options.componentRefreshCallback) {
	            this.domElement.on(Coveo.QueryEvents.deferredQuerySuccess, function () {
	                _this.options.componentRefreshCallback();
	            });
	            this.domElement.on(Coveo.QueryEvents.queryError, function () {
	                _this.options.componentRefreshCallback();
	            });
	        }
	    };
	    CoveoForSitecoreBase.prototype.isInPageEditor = function () {
	        return this.options.isEditingInPageEditor ||
	            this.options.isPreviewingInPageEditor ||
	            this.options.isPreviewingInPageEditorWithSimulatedDevice;
	    };
	    CoveoForSitecoreBase.prototype.configureOmnibox = function (options) {
	        this.domElement.on(Coveo.OmniboxEvents.populateOmnibox, this.generatePopulateOmniboxFunction(options));
	    };
	    CoveoForSitecoreBase.prototype.trySetOriginContextInUsageAnalytics = function () {
	        var searchInterfaceComponent = Coveo.get(this.domElement.el, Coveo.SearchInterface, true);
	        if (searchInterfaceComponent && searchInterfaceComponent.usageAnalytics) {
	            searchInterfaceComponent.usageAnalytics.setOriginContext("WebsiteSearch");
	        }
	    };
	    CoveoForSitecoreBase.prototype.addContextToQuery = function (queryBuilder) {
	        var _this = this;
	        if (typeof (queryBuilder.context) === "undefined") {
	            queryBuilder.context = {};
	        }
	        Object.keys(this.options.userContext).map(function (key) {
	            return {
	                key: key,
	                value: _this.options.userContext[key]
	            };
	        }).filter(function (pair) {
	            return pair.value !== "";
	        }).forEach(function (pair) {
	            queryBuilder.context[pair.key] = pair.value;
	        });
	    };
	    CoveoForSitecoreBase.prototype.getOptionsWithTabExternalContent = function (currentTabId) {
	        var filterExpressionOptions = _.extend({}, this.options);
	        if (typeof (currentTabId) !== "undefined" && this.options.hasOwnProperty(currentTabId)) {
	            var tabOptions = this.options[currentTabId];
	            filterExpressionOptions.externalSourcesFromCurrentTab = tabOptions.externalSources;
	            filterExpressionOptions.externalCollectionsFromCurrentTab = tabOptions.externalCollections;
	        }
	        return filterExpressionOptions;
	    };
	    CoveoForSitecoreBase.prototype.generatePopulateOmniboxFunction = function (options) {
	        var _this = this;
	        var queryController = Coveo.get(this.element).queryController;
	        return function (e, populateOmniboxObject) {
	            _this.omniboxResultListHandler.populateOmniboxResultList(populateOmniboxObject, options, queryController);
	        };
	    };
	    CoveoForSitecoreBase.prototype.getDomElementsMatchingSelector = function (querySelector) {
	        // Using .map to pass from NodeListOf<Element> to Array<Element> type. Can't do a direct cast.
	        return _.map(document.querySelectorAll(querySelector), function (element) {
	            return Coveo.$$(element);
	        });
	    };
	    return CoveoForSitecoreBase;
	}());
	exports.__esModule = true;
	exports["default"] = CoveoForSitecoreBase;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	var Logger = (function () {
	    function Logger(enableClientSideLogging) {
	        this.enableClientSideLogging = enableClientSideLogging;
	    }
	    Logger.prototype.log = function (message) {
	        if (this.enableClientSideLogging) {
	            console.log(["TRACE", "Coveo for Sitecore"].concat(message));
	        }
	    };
	    return Logger;
	}());
	exports.__esModule = true;
	exports["default"] = Logger;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	var DefaultSortHandler = (function () {
	    function DefaultSortHandler(defaultSortOptions) {
	        this.fieldSortType = "Field";
	        this.defaultSortOptions = defaultSortOptions;
	    }
	    DefaultSortHandler.prototype.addSortCriteriaToQuery = function (queryBuilder) {
	        queryBuilder.sortCriteria = this.defaultSortOptions.defaultSortCriteriaLowercase;
	        if (this.defaultSortOptions.defaultSortType === this.fieldSortType) {
	            queryBuilder.sortField = this.defaultSortOptions.defaultSortField;
	        }
	    };
	    return DefaultSortHandler;
	}());
	exports.__esModule = true;
	exports["default"] = DefaultSortHandler;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	var SearchExpressionsHelper_1 = __webpack_require__(9);
	var FilterExpressionHelper_1 = __webpack_require__(10);
	var ExpressionHelperUtilities_1 = __webpack_require__(11);
	var ExpressionsHelper = (function () {
	    function ExpressionsHelper(filterExpressionHelper, searchExpressionHelper) {
	        var expressionHelperUtilities = new ExpressionHelperUtilities_1["default"]();
	        this.filterExpressionHelper = filterExpressionHelper || new FilterExpressionHelper_1["default"](expressionHelperUtilities);
	        this.searchExpressionHelper = searchExpressionHelper || new SearchExpressionsHelper_1["default"](expressionHelperUtilities);
	    }
	    ExpressionsHelper.prototype.getFilterExpression = function (options) {
	        var expression = this.filterExpressionHelper.getContextFilterExpressions(options);
	        return this.filterExpressionHelper.appendExternalContentToExpression(expression, options);
	    };
	    ExpressionsHelper.prototype.getSearchExpression = function (options) {
	        var expressions = [
	            this.searchExpressionHelper.getSourcesAndCollectionsExpression(options, options, options),
	            this.searchExpressionHelper.getSearchFilterExpression(options, options),
	            this.searchExpressionHelper.getSearchBoostExpression(options)
	        ];
	        return expressions.filter(function (expression) { return expression !== ""; }).join(" ");
	    };
	    ;
	    return ExpressionsHelper;
	}());
	exports.__esModule = true;
	exports["default"] = ExpressionsHelper;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	var SearchExpressionHelper = (function () {
	    function SearchExpressionHelper(expressionHelperUtilities) {
	        this.utilities = expressionHelperUtilities;
	    }
	    SearchExpressionHelper.prototype.getSourcesAndCollectionsExpression = function (collectionsOptions, sourcesOptions, externalContentFromCurrentTab) {
	        var newExpression;
	        var sourcesExpression = this.getSourcesExpression(sourcesOptions, externalContentFromCurrentTab);
	        var externalCollections = this.getAllExternalCollections(collectionsOptions, externalContentFromCurrentTab);
	        if (externalCollections.length > 0) {
	            var externalCollectionsExpression = this.utilities.getExternalCollectionsExpression(externalCollections);
	            newExpression = "(" + sourcesExpression + " OR " + externalCollectionsExpression + ")";
	        }
	        else {
	            newExpression = sourcesExpression;
	        }
	        return newExpression;
	    };
	    SearchExpressionHelper.prototype.getSearchFilterExpression = function (options, externalContentFromCurrentTab) {
	        var expressions = [options.filterExpression];
	        if (externalContentFromCurrentTab.externalSourcesFromCurrentTab.length > 0) {
	            expressions.push(this.utilities.getExternalSourcesExpression(externalContentFromCurrentTab.externalSourcesFromCurrentTab));
	        }
	        if (externalContentFromCurrentTab.externalCollectionsFromCurrentTab.length > 0) {
	            expressions.push(this.utilities.getExternalCollectionsExpression(externalContentFromCurrentTab.externalCollectionsFromCurrentTab));
	        }
	        return expressions.join(" OR ");
	    };
	    SearchExpressionHelper.prototype.getSearchBoostExpression = function (options) {
	        return options.boostExpressions;
	    };
	    SearchExpressionHelper.prototype.getSourcesExpression = function (sourcesExpressionOptions, externalContentFromCurrentTab) {
	        var sources = [];
	        if (this.utilities.isDefined(sourcesExpressionOptions.indexSourceName)) {
	            sources.push(sourcesExpressionOptions.indexSourceName);
	        }
	        if (sourcesExpressionOptions.externalSources.length > 0) {
	            sources.push.apply(sources, sourcesExpressionOptions.externalSources);
	        }
	        if (externalContentFromCurrentTab.externalSourcesFromCurrentTab.length > 0) {
	            sources.push.apply(sources, externalContentFromCurrentTab.externalSourcesFromCurrentTab);
	        }
	        return this.utilities.getFilterExpression("@syssource", sources);
	    };
	    SearchExpressionHelper.prototype.getAllExternalCollections = function (externalCollectionsOptions, externalContentFromCurrentTabOptions) {
	        var externalSources = [];
	        externalSources.push.apply(externalSources, externalCollectionsOptions.externalCollections);
	        externalSources.push.apply(externalSources, externalContentFromCurrentTabOptions.externalCollectionsFromCurrentTab);
	        return externalSources;
	    };
	    return SearchExpressionHelper;
	}());
	exports.__esModule = true;
	exports["default"] = SearchExpressionHelper;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	var FilterExpressionHelper = (function () {
	    function FilterExpressionHelper(expressionHelperUtilities) {
	        this.utilities = expressionHelperUtilities;
	    }
	    FilterExpressionHelper.prototype.getFilterExpressions = function (options) {
	        var filterExpressions = this.getContextFilterExpressions(options);
	        var filterExpressionsWithExternalContent = this.appendExternalContentToExpression(filterExpressions, options);
	        return filterExpressionsWithExternalContent;
	    };
	    ;
	    FilterExpressionHelper.prototype.getContextFilterExpressions = function (options) {
	        var expression = "";
	        var filterExpressions = [];
	        if (options.filterResultsOnCurrentCulture) {
	            var clientLanguageFilterExpression = this.utilities.getFilterExpression(options.clientLanguageFieldName, options.clientLanguageName);
	            filterExpressions.push(clientLanguageFilterExpression);
	        }
	        if (options.filterResultOnLatestVersion) {
	            var latestVersionFilterExpression = this.utilities.getFilterExpression(options.latestVersionFieldName, "1");
	            filterExpressions.push(latestVersionFilterExpression);
	        }
	        if (filterExpressions.length > 0) {
	            var filterExpression = filterExpressions.join(" ").replace(/^\s+|\s+$/g, "");
	            expression = "(" + filterExpression + ")";
	        }
	        return expression;
	    };
	    FilterExpressionHelper.prototype.appendExternalContentToExpression = function (expression, options) {
	        var newExpression = expression;
	        if (this.hasExternalContentSpecified(options)) {
	            var expressions = [expression];
	            var externalSources = this.getAllExternalSources(options, options);
	            if (externalSources.length > 0) {
	                expressions.push(this.utilities.getExternalSourcesExpression(externalSources));
	            }
	            var externalCollections = this.getAllExternalCollections(options, options);
	            if (externalCollections.length > 0) {
	                expressions.push(this.utilities.getExternalCollectionsExpression(externalCollections));
	            }
	            newExpression = "(" + expressions.join(" OR ") + ")";
	        }
	        return newExpression;
	    };
	    ;
	    FilterExpressionHelper.prototype.getAllExternalSources = function (externalSourcesOptions, externalContentFromCurrentTabOptions) {
	        var externalSources = [];
	        externalSources.push.apply(externalSources, externalSourcesOptions.externalSources);
	        externalSources.push.apply(externalSources, externalContentFromCurrentTabOptions.externalSourcesFromCurrentTab);
	        return externalSources;
	    };
	    FilterExpressionHelper.prototype.getAllExternalCollections = function (externalCollectionsOptions, externalContentFromCurrentTabOptions) {
	        var externalSources = [];
	        externalSources.push.apply(externalSources, externalCollectionsOptions.externalCollections);
	        externalSources.push.apply(externalSources, externalContentFromCurrentTabOptions.externalCollectionsFromCurrentTab);
	        return externalSources;
	    };
	    FilterExpressionHelper.prototype.hasExternalContentSpecified = function (options) {
	        return options.externalCollections.length > 0 ||
	            options.externalSources.length > 0 ||
	            options.externalSourcesFromCurrentTab.length > 0 ||
	            options.externalCollectionsFromCurrentTab.length > 0;
	    };
	    ;
	    return FilterExpressionHelper;
	}());
	exports.__esModule = true;
	exports["default"] = FilterExpressionHelper;


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	var ExpressionHelperUtilities = (function () {
	    function ExpressionHelperUtilities() {
	    }
	    ExpressionHelperUtilities.prototype.getFilterExpression = function (fieldName, fieldValue) {
	        if (typeof (fieldValue) == "string") {
	            return fieldName + "==\"" + fieldValue + "\"";
	        }
	        else {
	            var fieldValues = fieldValue;
	            if (fieldValues.length > 0) {
	                return fieldName + "==(\"" + fieldValues.join('","') + "\")";
	            }
	            else {
	                return "";
	            }
	        }
	    };
	    ;
	    ExpressionHelperUtilities.prototype.getExternalCollectionsExpression = function (externalCollections) {
	        return this.getFilterExpression("@syscollection", externalCollections);
	    };
	    ExpressionHelperUtilities.prototype.getExternalSourcesExpression = function (externalSources) {
	        return this.getFilterExpression("@syssource", externalSources);
	    };
	    ExpressionHelperUtilities.prototype.isDefined = function (property) {
	        return typeof property !== "undefined";
	    };
	    return ExpressionHelperUtilities;
	}());
	exports.__esModule = true;
	exports["default"] = ExpressionHelperUtilities;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	var Coveo = __webpack_require__(5);
	var SearchEndpointHelper = (function () {
	    function SearchEndpointHelper() {
	    }
	    SearchEndpointHelper.initializeEndpoint = function (options) {
	        Coveo.SearchEndpoint.endpoints["default"] = new Coveo.SearchEndpoint({
	            restUri: options.restEndpointUri,
	            queryStringArguments: { 'sitecoreItemUri': options.sitecoreItemUri, 'siteName': options.siteName }
	        });
	    };
	    return SearchEndpointHelper;
	}());
	exports.__esModule = true;
	exports["default"] = SearchEndpointHelper;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	var Coveo = __webpack_require__(5);
	var OmniboxResultListHandler = (function () {
	    function OmniboxResultListHandler() {
	    }
	    OmniboxResultListHandler.getOmniboxDataRowIndex = function () {
	        this.omniboxDataRowIndexCounter = this.omniboxDataRowIndexCounter + 1;
	        return this.omniboxDataRowIndexCounter;
	    };
	    OmniboxResultListHandler.prototype.onOmniboxRowClicked = function (result) {
	        window.location.href = result.clickUri;
	    };
	    OmniboxResultListHandler.prototype.buildOmniboxContent = function (results, options) {
	        var _this = this;
	        var id = options.id ? options.id : options.resultTemplateId;
	        var templateElement = document.getElementById(id);
	        var template = new Coveo.UnderscoreTemplate(templateElement);
	        var resultContainer = this.getResultContainer(options.headerTitle);
	        var content = Coveo.$$("div");
	        content.append(resultContainer.el);
	        results.forEach(function (result) {
	            var oneRowOfContent = template.instantiateToElement(result);
	            var rowElement = Coveo.$$(oneRowOfContent);
	            rowElement.addClass("CoveoResult coveo-omnibox-selectable");
	            rowElement.on("click keyboardSelect", function () {
	                _this.onOmniboxRowClicked(result);
	            });
	            content.append(oneRowOfContent);
	        });
	        return content.el;
	    };
	    OmniboxResultListHandler.prototype.populateOmniboxResultList = function (populateOmniboxObject, options, queryController) {
	        var _this = this;
	        var queryBuilder = queryController.createQueryBuilder(options);
	        if (options.queryExpression && typeof (options.queryExpression) === "string") {
	            queryBuilder.advancedExpression.add(options.queryExpression);
	        }
	        queryBuilder.numberOfResults = options.numberOfResults;
	        var query = queryBuilder.build();
	        var promise = this.executeSearchQuery(query)
	            .then(function (response) {
	            if (response.totalCount > 0) {
	                var elementToReturn = _this.buildOmniboxContent(response.results, options);
	                var objectToReturn = {
	                    zIndex: options.omniboxDataRowIndex,
	                    element: elementToReturn
	                };
	                return objectToReturn;
	            }
	            else {
	                return { element: undefined };
	            }
	        });
	        populateOmniboxObject.rows.push({ deferred: promise });
	    };
	    OmniboxResultListHandler.prototype.executeSearchQuery = function (query) {
	        return Coveo.SearchEndpoint.endpoints["default"].search(query);
	    };
	    OmniboxResultListHandler.prototype.getResultContainer = function (captionText) {
	        var resultContainer = Coveo.$$("div");
	        resultContainer.addClass("coveo-omnibox-result-list-header");
	        resultContainer.append(this.getIcon().el);
	        resultContainer.append(this.getCaption(captionText).el);
	        return resultContainer;
	    };
	    OmniboxResultListHandler.prototype.getIcon = function () {
	        var iconResultList = Coveo.$$("span");
	        iconResultList.addClass("coveo-icon-omnibox-result-list");
	        return iconResultList;
	    };
	    OmniboxResultListHandler.prototype.getCaption = function (captionText) {
	        var caption = Coveo.$$("span");
	        caption.addClass("coveo-caption");
	        caption.el.textContent = captionText;
	        return caption;
	    };
	    OmniboxResultListHandler.omniboxDataRowIndexCounter = 0;
	    return OmniboxResultListHandler;
	}());
	exports.__esModule = true;
	exports["default"] = OmniboxResultListHandler;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	/// <reference path="../../../typings/coveo-search-ui/CoveoJsSearch.d.ts"/>
	var Coveo = __webpack_require__(5);
	var Utilities_1 = __webpack_require__(15);
	var EndpointCaller_1 = __webpack_require__(16);
	var SitecoreAnalyticsHandler = (function () {
	    function SitecoreAnalyticsHandler(options, endpointCaller) {
	        this.options = options;
	        this.endpointCaller = endpointCaller || new EndpointCaller_1["default"]();
	    }
	    SitecoreAnalyticsHandler.prototype.registerSitecoreAnalytics = function (domElement, windowReference) {
	        var _this = this;
	        // Make sure to flush Analytics events on document clicks.
	        (windowReference || window).onbeforeunload = function () {
	            Coveo.Defer.flush();
	        };
	        domElement.on(Coveo.AnalyticsEvents.searchEvent, function (e, args) {
	            _this.postAnalytics("searches", "searchEvents", args.searchEvents);
	        });
	        domElement.on(Coveo.AnalyticsEvents.documentViewEvent, function (e, args) {
	            _this.postAnalytics("documentViews", "documentViewEvents", args.documentViewEvent);
	        });
	        domElement.on(Coveo.AnalyticsEvents.customEvent, function (e, args) {
	            _this.postAnalytics("custom", "customEvents", args.customEvent);
	        });
	    };
	    SitecoreAnalyticsHandler.prototype.postAnalytics = function (eventAction, eventType, eventData) {
	        var _this = this;
	        var parsedEventData = [];
	        if (typeof (eventData) !== "undefined") {
	            parsedEventData = parsedEventData.concat(eventData);
	        }
	        parsedEventData.filter(function (data) {
	            return typeof (data) !== "undefined";
	        }).forEach(function (data) {
	            data.sitecoreItemId = _this.options.sitecoreItemId;
	        });
	        var postData = {};
	        postData[eventType] = JSON.stringify(parsedEventData);
	        this.endpointCaller.sendPost(Utilities_1["default"].appendTrailingSlash(this.options.analyticsEndpointUri) + eventAction, postData);
	    };
	    return SitecoreAnalyticsHandler;
	}());
	exports.__esModule = true;
	exports["default"] = SitecoreAnalyticsHandler;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	var Utilities = (function () {
	    function Utilities() {
	    }
	    Utilities.appendTrailingSlash = function (url) {
	        return url.charAt(url.length - 1) === "/" ? url : url + "/";
	    };
	    return Utilities;
	}());
	exports.__esModule = true;
	exports["default"] = Utilities;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	/// <reference path="../../typings/coveo-search-ui/CoveoJsSearch.d.ts"/>
	var Coveo = __webpack_require__(5);
	var EndpointCaller = (function () {
	    function EndpointCaller(endpointCaller) {
	        this.endpointCaller = endpointCaller || new Coveo.EndpointCaller();
	    }
	    EndpointCaller.prototype.sendPost = function (url, postData) {
	        var callOptions = {
	            errorsAsSuccess: false,
	            method: "POST",
	            queryString: [],
	            requestData: postData,
	            url: url,
	            responseType: "text",
	            requestDataType: "application/json"
	        };
	        return this.endpointCaller.call(callOptions);
	    };
	    return EndpointCaller;
	}());
	exports.__esModule = true;
	exports["default"] = EndpointCaller;


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	var TabsBinding = (function () {
	    function TabsBinding() {
	        var _this = this;
	        this.bindings = {};
	        this.getElementBinding = function (elementId) {
	            return {
	                elementId: elementId,
	                document: document.getElementById(elementId),
	                binding: _this.bindings[elementId]
	            };
	        };
	        this.elementFound = function (elementBinding) {
	            var elementFound = typeof (elementBinding.document) !== "undefined" && elementBinding.document != null;
	            if (!elementFound) {
	                console.error("The element with the ID '" + elementBinding.elementId + "' was not found. Ensure the element exists in the DOM.");
	            }
	            return elementFound;
	        };
	        this.initBinding = function (itemId) {
	            if (!_this.bindings.hasOwnProperty(itemId)) {
	                _this.bindings[itemId] = {
	                    tabNot: []
	                };
	            }
	            return _this.bindings[itemId];
	        };
	        this.applyBinding = function (elementBinding) {
	            _this.addExcludeFromTabTag(elementBinding.document, elementBinding.binding.tabNot);
	        };
	        this.addExcludeFromTabTag = function (element, bindings) {
	            if (bindings.length > 0) {
	                element.setAttribute("data-tab-not", bindings.join(","));
	            }
	        };
	    }
	    TabsBinding.prototype.excludeItemsIdsInTab = function (elementIds, tabId) {
	        elementIds.map(this.initBinding, this).forEach(function (binding) {
	            binding.tabNot.push(tabId);
	        });
	    };
	    TabsBinding.prototype.applyBindings = function () {
	        Object.keys(this.bindings)
	            .map(this.getElementBinding)
	            .filter(this.elementFound)
	            .forEach(this.applyBinding);
	    };
	    return TabsBinding;
	}());
	exports.__esModule = true;
	exports["default"] = TabsBinding;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Coveo = __webpack_require__(5);
	var CoveoForSitecoreBase_1 = __webpack_require__(4);
	var Searchbox = (function (_super) {
	    __extends(Searchbox, _super);
	    function Searchbox(searchComponent, searchBoxPluginOptions, defaultSearchBoxPluginOptions) {
	        _super.call(this, searchComponent, searchBoxPluginOptions, defaultSearchBoxPluginOptions);
	        this.searchBoxOptions = _.extend({}, defaultSearchBoxPluginOptions, searchBoxPluginOptions);
	    }
	    Searchbox.prototype.initialize = function () {
	        var _this = this;
	        this.logger.log("Initializing searchbox.");
	        this.initializeSearchOptions();
	        if (!this.options.isInitialized) {
	            this.domElement.on(Coveo.QueryEvents.buildingQuery, function (e, args) {
	                var expression = _this.expressionsHelper.getSearchExpression(_this.searchBoxOptions);
	                args.queryBuilder.advancedExpression.add(expression);
	            });
	        }
	        Coveo.initSearchbox(this.element, this.searchBoxOptions.searchRedirectionUrl, this.searchBoxOptions);
	        if (this.searchBoxOptions.searchRedirectionItemName) {
	            var searchBoxComponent = Coveo.get(this.element, Coveo.SearchInterface);
	            if (searchBoxComponent) {
	                searchBoxComponent.componentOptionsModel.set("searchHub", this.searchBoxOptions.searchRedirectionItemName);
	            }
	        }
	        this.doPostInitializationActions();
	    };
	    return Searchbox;
	}(CoveoForSitecoreBase_1["default"]));
	exports.__esModule = true;
	exports["default"] = Searchbox;


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	var UserContextHandler = (function () {
	    function UserContextHandler() {
	        this.context = {};
	    }
	    UserContextHandler.prototype.initializeContext = function (context) {
	        this.context = this.replaceInvalidCharacterInContext(context);
	        return this;
	    };
	    UserContextHandler.prototype.setContext = function (key, value) {
	        this.context[this.replaceInvalidCharacters(key)] = value;
	        return this;
	    };
	    UserContextHandler.prototype.getContext = function () {
	        return this.context;
	    };
	    UserContextHandler.prototype.replaceInvalidCharacterInContext = function (context) {
	        var _this = this;
	        var validContext = {};
	        Object.keys(context).forEach(function (key) {
	            validContext[_this.replaceInvalidCharacters(key)] = context[key];
	        });
	        return validContext;
	    };
	    UserContextHandler.prototype.replaceInvalidCharacters = function (key) {
	        if (typeof key === "string") {
	            return key.replace(UserContextHandler.invalidCharacters, "_");
	        }
	        else {
	            console.error("The user context key '{key}' is not a string.");
	            return "";
	        }
	    };
	    UserContextHandler.invalidCharacters = /[^A-Za-z0-9_]/ig;
	    return UserContextHandler;
	}());
	exports.__esModule = true;
	exports["default"] = UserContextHandler;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_20__;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	/// <reference path="../../../typings/coveo-search-ui/CoveoJsSearch.d.ts"/>
	var Coveo = __webpack_require__(5);
	var DefaultSortHandler_1 = __webpack_require__(7);
	var SitecoreAnalyticsHandler_1 = __webpack_require__(14);
	var ExpressionHelperUtilities_1 = __webpack_require__(11);
	var CoveoForSitecoreRecommendations = (function () {
	    function CoveoForSitecoreRecommendations() {
	    }
	    CoveoForSitecoreRecommendations.prototype.initRelatedQuery = function (element, searchInterfaceElement, userContext, options) {
	        var expressionHelperUtilities = new ExpressionHelperUtilities_1["default"]();
	        var defaultSortHandler = new DefaultSortHandler_1["default"](options);
	        var domElement = Coveo.$$(element);
	        domElement.on(Coveo.QueryEvents.buildingQuery, function (event, args) {
	            defaultSortHandler.addSortCriteriaToQuery(args.queryBuilder);
	            if (options.filterResultsOnCurrentCulture) {
	                var languageFilterExpression = expressionHelperUtilities.getFilterExpression(options.clientLanguageFieldName, options.clientLanguageName);
	                args.queryBuilder.constantExpression.add(languageFilterExpression);
	            }
	        });
	        if (options && options.sendToSitecoreAnalytics) {
	            var sitecoreAnalyticsHandler = new SitecoreAnalyticsHandler_1["default"](options);
	            sitecoreAnalyticsHandler.registerSitecoreAnalytics(domElement);
	        }
	        Coveo.initRecommendation(element, searchInterfaceElement, userContext, options);
	    };
	    CoveoForSitecoreRecommendations.prototype.initRecommendations = function (element, userContext) {
	        Coveo.initRecommendation(element, null, userContext);
	    };
	    return CoveoForSitecoreRecommendations;
	}());
	exports.__esModule = true;
	exports["default"] = CoveoForSitecoreRecommendations;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/// <reference path="../../../typings/coveo-search-ui/CoveoJsSearch.d.ts"/>
	var Coveo = __webpack_require__(5);
	var OmniboxResultListHandler_1 = __webpack_require__(13);
	var Component = Coveo.Component;
	var OmniboxResultList = (function (_super) {
	    __extends(OmniboxResultList, _super);
	    function OmniboxResultList(element, options, bindings) {
	        _super.call(this, element, OmniboxResultList.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.omniboxResultListHandler = new OmniboxResultListHandler_1["default"]();
	        this.options = Coveo.ComponentOptions.initComponentOptions(element, OmniboxResultList, options);
	        if (bindings) {
	            this.initializeOmniboxDataRowIndex(bindings);
	        }
	        this.bind.onRootElement(Coveo.OmniboxEvents.populateOmnibox, this.populateOmnibox);
	        this.bindEnterToSearchButton();
	    }
	    // The enter button stops working when calling "queryController.createQueryBuilder(options);" in the populateOmnibox event.
	    // This ugly workaround fixes the enter button.
	    OmniboxResultList.prototype.bindEnterToSearchButton = function () {
	        var queryBoxes = document.querySelectorAll(".CoveoSearchbox");
	        _.map(queryBoxes, function (queryBox) {
	            return {
	                input: queryBox.querySelector("input"),
	                button: queryBox.querySelector(".CoveoSearchButton")
	            };
	        }).filter(function (queryBoxElements) {
	            return queryBoxElements.button !== null && queryBoxElements.input !== null;
	        }).forEach(function (queryBoxElements) {
	            queryBoxElements.input.addEventListener("keydown", function (event) {
	                if (event.keyCode === 13) {
	                    queryBoxElements.button.click();
	                }
	            });
	        });
	    };
	    OmniboxResultList.prototype.populateOmnibox = function (populateOmniboxObject) {
	        this.omniboxResultListHandler.populateOmniboxResultList(populateOmniboxObject, this.options, this.queryController);
	    };
	    OmniboxResultList.prototype.initializeOmniboxDataRowIndex = function (bindings) {
	        // "as HTMLElement" is needed in TypeScript 1.5, see details here: https://github.com/Microsoft/TypeScript/issues/4401
	        var omniboxResultList = document.getElementsByClassName("CoveoForSitecoreOmniboxResultList")[0];
	        if (!bindings.searchInterface.options.originalOptionsObject.keepOmniboxSuggestionsProvidersDefaultOrdering) {
	            // 51 is the default z-index of the JS Search OmniboxResultList.
	            // We make sure that the last omnibox index is 51, the before last index is 52 and so on.
	            this.options.omniboxDataRowIndex = 51 + Coveo.$$(omniboxResultList).children().length - bindings.searchInterface.options.originalOptionsObject.omniboxDataRowIndexCounter;
	            bindings.searchInterface.options.originalOptionsObject.omniboxDataRowIndexCounter++;
	        }
	    };
	    OmniboxResultList.ID = "ForSitecoreOmniboxResultList";
	    OmniboxResultList.options = {
	        headerTitle: Coveo.ComponentOptions.buildStringOption(),
	        queryExpression: Coveo.ComponentOptions.buildStringOption(),
	        numberOfResults: Coveo.ComponentOptions.buildNumberOption({ defaultValue: 10, min: 1 }),
	        omniboxDataRowIndex: Coveo.ComponentOptions.buildNumberOption({ defaultValue: 51, min: 16 }),
	        resultTemplateId: Coveo.ComponentOptions.buildStringOption()
	    };
	    return OmniboxResultList;
	}(Component));
	exports.OmniboxResultList = OmniboxResultList;
	Coveo.Initialization.registerAutoCreateComponent(OmniboxResultList);


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright (c) 2005-2019, Coveo Solutions Inc.
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var coveo_search_ui_1 = __webpack_require__(5);
	var EndpointCaller_1 = __webpack_require__(16);
	var GOOGLE_PROVIDER_VALUE = "google";
	var SITECORE_PROVIDER_VALUE = "sitecoreGeolocation";
	var BROWSER_PROVIDER_VALUE = "browser";
	var CUSTOM_PROVIDER_VALUE = "custom";
	var GOOGLE_MAP_BASE_URL = "https://www.googleapis.com/geolocation/v1/geolocate?key=";
	var CoveoForSitecoreDistanceResources = (function (_super) {
	    __extends(CoveoForSitecoreDistanceResources, _super);
	    /** Initialize the distance resources component that queries distance */
	    function CoveoForSitecoreDistanceResources(element, options, bindings) {
	        _super.call(this, element, CoveoForSitecoreDistanceResources.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.providerWarningDisabled = false;
	        this.options = coveo_search_ui_1.ComponentOptions.initComponentOptions(element, CoveoForSitecoreDistanceResources, options);
	        this.endpointCaller = new EndpointCaller_1["default"]();
	        if (this.options.geolocationProviders) {
	            this.options.geolocationProviders = this.options.geolocationProviders.reverse();
	            this.tryNextGeolocationProvider();
	        }
	    }
	    CoveoForSitecoreDistanceResources.prototype.setDistance = function (latitude, longitude) {
	        this.latitude = latitude;
	        this.longitude = longitude;
	        this.registerDistanceQuery();
	        this.queryController.executeQuery();
	    };
	    CoveoForSitecoreDistanceResources.prototype.setCoordinateFromGoogle = function () {
	        var _this = this;
	        if (!!this.options.googleApiKey) {
	            var postData = {};
	            var baseMapsUrl = GOOGLE_MAP_BASE_URL + this.options.googleApiKey;
	            var geolocationResponse = this.endpointCaller.sendPost(baseMapsUrl, postData);
	            geolocationResponse.then(function (positionData) {
	                var location = positionData.data.location;
	                if (!!location) {
	                    _this.setDistance(location.lat, location.lng);
	                }
	                else {
	                    _this.tryNextGeolocationProvider();
	                }
	            });
	        }
	        else {
	            this.logger.error(GOOGLE_PROVIDER_VALUE + " provider was selected, but \"googleApiKey\" option was not set.");
	            this.tryNextGeolocationProvider();
	        }
	    };
	    CoveoForSitecoreDistanceResources.prototype.setDefaultCoordinates = function () {
	        if (!this.isNullOrEmpty(this.options.defaultLatitude) && !this.isNullOrEmpty(this.options.defaultLongitude)) {
	            this.setDistance(this.options.defaultLatitude, this.options.defaultLongitude);
	        }
	        else {
	            this.logger.error(SITECORE_PROVIDER_VALUE + " provider was selected, but \"defaultLongitude\" and \"defaultLatitude\" options were not set.");
	            this.tryNextGeolocationProvider();
	        }
	    };
	    CoveoForSitecoreDistanceResources.prototype.setCoordinatesFromBrowser = function () {
	        var _this = this;
	        navigator.geolocation.getCurrentPosition(function (position) {
	            _this.setDistance(position.coords.latitude, position.coords.longitude);
	        }, function (err) {
	            _this.tryNextGeolocationProvider();
	        });
	    };
	    CoveoForSitecoreDistanceResources.prototype.registerDistanceQuery = function () {
	        var _this = this;
	        this.bind.onRootElement(Coveo.QueryEvents.buildingQuery, function (args) {
	            var geoQueryFunction = {
	                'function': _this.getConvertedUnitsFunction("dist(" + _this.options.latitudeField + ", " + _this.options.longitudeField + ", " + _this.latitude + ", " + _this.longitude + ")"),
	                'fieldName': _this.options.distanceField
	            };
	            if (args && args.queryBuilder) {
	                args.queryBuilder.queryFunctions.push(geoQueryFunction);
	                _this.enableDistanceComponents();
	            }
	        });
	    };
	    CoveoForSitecoreDistanceResources.prototype.enableDistanceComponents = function () {
	        var _this = this;
	        // Don't iterate directly on "distanceComponents", since we remove the class, the element also gets removed from the iterator in the "for-loop".
	        var distanceComponents = document.getElementsByClassName(this.options.disabledDistanceCssClass);
	        var elements = [];
	        for (var i = 0, length_1 = distanceComponents.length; i < length_1; i++) {
	            elements.push(distanceComponents.item(i));
	        }
	        elements.forEach(function (element) {
	            try {
	                element.classList.remove(_this.options.disabledDistanceCssClass);
	                Coveo.get(element).enable();
	            }
	            catch (exception) {
	                _this.logger.error("Could not re-enable distance component:", exception, element);
	            }
	        });
	    };
	    CoveoForSitecoreDistanceResources.prototype.getConvertedUnitsFunction = function (queryFunction) {
	        return queryFunction + "/" + this.options.unitConversionFactor;
	    };
	    CoveoForSitecoreDistanceResources.prototype.tryNextGeolocationProvider = function () {
	        var currentGeolocationProvider = this.options.geolocationProviders.pop();
	        if (currentGeolocationProvider == null) {
	            if (!this.providerWarningDisabled) {
	                console.warn("None of the mentioned geolocation providers were able to provide the user's coordinates. The distance field will not be calculated and the distance components will be disabled until the next call to \"setDistance\".");
	            }
	        }
	        else {
	            switch (currentGeolocationProvider) {
	                case GOOGLE_PROVIDER_VALUE:
	                    this.setCoordinateFromGoogle();
	                    break;
	                case CUSTOM_PROVIDER_VALUE:
	                    this.providerWarningDisabled = true;
	                    break;
	                case SITECORE_PROVIDER_VALUE:
	                    this.setDefaultCoordinates();
	                    break;
	                case BROWSER_PROVIDER_VALUE:
	                    this.setCoordinatesFromBrowser();
	                    break;
	                default:
	                    console.warn("Invalid geolocation provider: '" + currentGeolocationProvider + "'.");
	                    this.tryNextGeolocationProvider();
	            }
	        }
	    };
	    CoveoForSitecoreDistanceResources.prototype.isNullOrEmpty = function (value) {
	        return value === null || typeof (value) === "undefined";
	    };
	    CoveoForSitecoreDistanceResources.ID = "ForSitecoreDistanceResources";
	    CoveoForSitecoreDistanceResources.options = {
	        distanceField: coveo_search_ui_1.ComponentOptions.buildStringOption(),
	        latitudeField: coveo_search_ui_1.ComponentOptions.buildStringOption(),
	        longitudeField: coveo_search_ui_1.ComponentOptions.buildStringOption(),
	        defaultLatitude: coveo_search_ui_1.ComponentOptions.buildNumberOption(),
	        defaultLongitude: coveo_search_ui_1.ComponentOptions.buildNumberOption(),
	        geolocationProviders: coveo_search_ui_1.ComponentOptions.buildListOption(),
	        googleApiKey: coveo_search_ui_1.ComponentOptions.buildStringOption(),
	        unitType: coveo_search_ui_1.ComponentOptions.buildStringOption(),
	        unitConversionFactor: coveo_search_ui_1.ComponentOptions.buildStringOption(),
	        disabledDistanceCssClass: coveo_search_ui_1.ComponentOptions.buildStringOption({
	            defaultValue: "coveo-distance-disabled"
	        })
	    };
	    return CoveoForSitecoreDistanceResources;
	}(coveo_search_ui_1.Component));
	exports.CoveoForSitecoreDistanceResources = CoveoForSitecoreDistanceResources;
	coveo_search_ui_1.Initialization.registerAutoCreateComponent(CoveoForSitecoreDistanceResources);


/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// CoveoForSitecore.min.js